import React from "react";
import { Modal } from "react-bootstrap";
import Blocker from "../../../Misc/Blocker";
import Context from "../../../../Context";
import PerfectScrollbar from "react-perfect-scrollbar";

export default class UserGroupPick extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      activeItem: false,
      search: "",
      items: {},
    };
  }

  load = async () => {
    this.setState({ pending: true });

    let groups = await this.context.api.qo("/admin/group/list");
    let users = await this.context.api.qo("/admin/user/list");
    let items = Object.assign({}, groups, users);
    this.setState({ pending: false, items });
  };

  select = () => {
    let item = this.state.items[this.state.activeItem] || {};
    this.props.onSelect(item);
    this.props.onHide();
  };

  search = (e) => {
    this.setState({ search: e.target.value });
  };

  componentDidMount() {
    this.load();
  }

  renderList() {
    if (Object.keys(this.state.items).length) {
      let search = this.state.search
        ? new RegExp(this.context.api.regexEscape(this.state.search), "gi")
        : false;

      return (
        <>
          <div className="">
            <table className="table w-100">
              <tbody>
                {Object.entries(this.state.items).map(([id, item]) => {
                  if (search) {
                    if (!search.test(item.name) && !search.test(item.username))
                      return null;
                  }
                  return (
                    <tr
                      key={id}
                      onClick={() => this.setState({ activeItem: id })}
                      onDoubleClick={() =>
                        this.setState({ activeItem: id }, () => this.select())
                      }
                      className={`cursor-pointer ${
                        this.state.activeItem === id
                          ? "bg-light-primary"
                          : "bg-hover-light"
                      }`}
                    >
                      <td className="text-nowrap align-middle">
                        {!item.created ? (
                          <span
                            title="Группа"
                            className="text-muted flaticon2-group mr-2"
                          ></span>
                        ) : (
                          <span
                            title="Пользователь"
                            className="text-muted flaticon2-user-outline-symbol mr-2"
                          ></span>
                        )}{" "}
                        {item.name}
                      </td>
                      <td className="font-size-sm">
                        {item.username}
                        <div className="text-muted">{item.description}</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      );
    }
  }

  render() {
    return (
      <>
        <Modal show={this.props.show} onHide={this.props.onHide}>
          <Modal.Header closeButton>
            <input
              value={this.state.search}
              onChange={this.search}
              type="text"
              className="form-control w-100"
              placeholder="Поиск..."
            />
          </Modal.Header>
          <Modal.Body>
            <Blocker on={this.state.pending}>
              <div style={{ height: "320px" }}>
                <PerfectScrollbar>{this.renderList()}</PerfectScrollbar>
              </div>
              <div className="mt-4  ">
                <button className="btn btn-primary mr-2" onClick={this.select}>
                  Добавить
                </button>
                <button className="btn btn-light" onClick={this.props.onHide}>
                  Отмена
                </button>
              </div>
            </Blocker>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
